import PropTypes from "prop-types";

import { CareerCompare } from "@features/career-compare";
import { CareerDetailsSheet } from "@features/shared/views/career-details.sheet";
import { Sheet } from "@features/ui";
import { useState } from "react";

export const CareerCompareSheet = ({
  open,
  onClose,
  onCreateBudget,
  onViewPathway,
}) => {
  const [career, setCareer] = useState();

  return (
    <>
      <Sheet open={open && !career} onClose={onClose}>
        <CareerCompare
          onClose={onClose}
          onCareerDetailsClick={setCareer}
          onCreateBudget={onCreateBudget}
          onViewPathway={onViewPathway}
        />
      </Sheet>
      <CareerDetailsSheet
        breadcrumbLabel="Compare"
        career={career}
        onClose={() => setCareer()}
        onBreadcrumbClick={() => setCareer()}
      />
    </>
  );
};

CareerCompareSheet.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onCreateBudget: PropTypes.func,
  onViewPathway: PropTypes.func,
};
